export const SCOPE_CATEGORY_NAMES = ['crm', 'cms', 'settings'];